// https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
// Safari < 14 and Opera not supporting MediaQueryList inherit from EventTarget
type ChangeEventHandler = (e: MediaQueryListEvent) => void;
export const addEventListener = (
  mediaQuery: MediaQueryList | null,
  callback: ChangeEventHandler,
  options?: EventListenerOptions
) => {
  if (!mediaQuery) {
    return;
  }

  if ('addEventListener' in mediaQuery) {
    mediaQuery.addEventListener('change', callback, options);
  } else {
    (mediaQuery as MediaQueryList).addListener(callback);
  }
};

export const removeEventListener = (
  mediaQuery: MediaQueryList | null,
  callback: ChangeEventHandler,
  options?: EventListenerOptions
) => {
  if (!mediaQuery) {
    return;
  }
  if ('removeEventListener' in mediaQuery) {
    mediaQuery.removeEventListener('change', callback, options);
  } else {
    (mediaQuery as MediaQueryList).removeListener(callback);
  }
};
